import { render, staticRenderFns } from "./storageData.vue?vue&type=template&id=4ac5c9e8&scoped=true"
import script from "./storageData.vue?vue&type=script&lang=js"
export * from "./storageData.vue?vue&type=script&lang=js"
import style0 from "./storageData.vue?vue&type=style&index=0&id=4ac5c9e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac5c9e8",
  null
  
)

export default component.exports